import { render, staticRenderFns } from "./testInstitutionsList.vue?vue&type=template&id=00b5a312&scoped=true"
import script from "./testInstitutionsList.vue?vue&type=script&lang=js"
export * from "./testInstitutionsList.vue?vue&type=script&lang=js"
import style0 from "./testInstitutionsList.vue?vue&type=style&index=0&id=00b5a312&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b5a312",
  null
  
)

export default component.exports